import cx from 'classnames';
import React from 'react';
import styles from './SimpleButtonAccordionIcon.module.scss';

interface ISimpleButtonAccordionIcon extends React.AllHTMLAttributes<HTMLSpanElement> {
  open: boolean;
}

export const SimpleButtonAccordionIcon: React.FC<ISimpleButtonAccordionIcon> = ({ open, className }) => (
  <div className={cx(styles.accordionIcon, className, { [styles.open]: open })}>
    <span className={styles.horizontalLine} />
    <span className={styles.verticalLine} />
  </div>
);
